import angular from "angular";
import Navbar from "./navbar/navbar";
import Hero from "./hero/hero";
import User from "./user/user";
import jobbleFooter from "./jobblefooter/jobblefooter";
import jobbleHeader from "./jobbleheader/jobbleheader";
import eventAddOpenings from "./eventaddopenings/eventaddopenings";
import eventSidebar from "./eventsidebar/eventsidebar";
import eventDropdownSidebar from "./eventdropdownsidebar/eventdropdownsidebar";
import adminSidebar from "./adminsidebar/adminsidebar";
import eventTab from "./eventtab/eventtab";
import loader from "./loader/loader";
import jobsdropdown from "./jobbleheader/jobsdropdown/jobsdropdown";
import pbjobsdropdown from "./pbheader/pbjobsdropdown/pbjobsdropdown";
import pjjobsdropdown from "./pjheader/pjjobsdropdown/pjjobsdropdown";
import track from "./track/track";
import sorry from "./sorry/sorry";
import Verification from "./verification/verification";
import jobblerProfile from "./jobblerprofile/jobblerprofile";
import eventDialog from "./eventdialog/eventdialog";
import paymentDialog from "./paymentdialog/paymentdialog";
import questionnaire from "./questionnaire/questionnaire";
import globalAlert from "./globalalert/globalalert";
import jobContact from "./jobcontact/jobcontact";
import googlePlaces from "./googleplaces/googleplaces";
import jobDetailsSignUp from "./jobdetailssignup/jobdetailssignup";
import globalModal from "./globalmodal/globalmodal";
import applyProfileModal from "./applyProfileModal/applyProfileModal";
import sendMessage from "./sendmessage/sendmessage";
import messagingGallery from "./messaginggallery/messaginggallery";
import jobSearch from "./jobsearch/jobsearch";
import postingDropDown from "./jobbleheader/postingdropdown/postingdropdown";
import pbpostingdropdown from "./pbheader/pbpostingdropdown/pbpostingdropdown";
import pjpostingdropdown from "./pjheader/pjpostingdropdown/pjpostingdropdown";
import leftnavigation from "./leftnavigation/leftnavigation";
import etaMap from "./etamap/etamap";
import branchioshare from "./branchioshare/branchioshare";
import pbheader from "./pbheader/pbheader";
import pjheader from "./pjheader/pjheader";
import jobdescription from "./jobdescription/jobdescription";
import jobsearchcard from "./jobsearchcard/jobsearchcard";
import pajtooltip from "./pajtooltip/pajtooltip";

import "./datepicker/datepicker-full";

let commonModule = angular.module("app.common", [
  Navbar.name,
  Hero.name,
  User.name,
  jobbleFooter.name,
  googlePlaces.name,
  jobsdropdown.name,
  pbjobsdropdown.name,
  pjjobsdropdown.name,
  jobbleHeader.name,
  eventAddOpenings.name,
  eventSidebar.name,
  postingDropDown.name,
  pbpostingdropdown.name,
  pjpostingdropdown.name,
  leftnavigation.name,
  jobDetailsSignUp.name,
  Verification.name,
  eventDropdownSidebar.name,
  adminSidebar.name,
  eventTab.name,
  branchioshare.name,
  jobContact.name,
  jobSearch.name,
  sendMessage.name,
  track.name,
  sorry.name,
  loader.name,
  jobblerProfile.name,
  applyProfileModal.name,
  eventDialog.name,
  paymentDialog.name,
  questionnaire.name,
  globalAlert.name,
  globalModal.name,
  messagingGallery.name,
  etaMap.name,
  pbheader.name,
  pjheader.name,
  jobdescription.name,
  jobsearchcard.name,
  pajtooltip.name,
]);

export default commonModule;



// WEBPACK FOOTER //
// ./client/app/common/common.js